import React from "react";
import NextLink from "next/link";
import routes from "@/helpers/router";
import { PageResourceCategory } from "@/components/PageArticleListing/helpers";
import styles from "./FilterResourceNavBar.module.scss";

interface FilterResourceNavBarProps {
  navBarData: any;
  pageCategory: string;
  resource: "articles" | "video";
}

const FilterResourceNavBar: React.FC<FilterResourceNavBarProps> = ({ navBarData, pageCategory, resource }) => {
  return (
    <div className={`${styles.chipsWrapper}`}>
      <div className={styles.chips}>
        <NextLink
          href={routes.resourcesListing(resource)}
          className={`${styles.chip} ${pageCategory === PageResourceCategory.resources ? styles.active : ""}`}
          prefetch={false}
        >
          All Stages
        </NextLink>
        {navBarData?.map(({ name, category, slug }) => {
          const isActive = pageCategory === category;

          return (
            <NextLink
              href={slug}
              prefetch={false}
              className={`${styles.chip} ${isActive ? styles.active : ""}`}
              key={slug}
            >
              {name}
            </NextLink>
          );
        })}
      </div>
    </div>
  );
};

export default FilterResourceNavBar;
